import { Component, input, output, signal, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { PremiumMembership } from '../../../shared/types/account.types';

@Component({
    selector: 'app-csa-option',
    imports: [],
    templateUrl: './csa-option.component.html',
    styleUrl: './csa-option.component.scss'
})
export class CsaOptionComponent implements OnChanges {

  //#region Properties

  onNextStep = output<number>();

  list = input.required<PremiumMembership[]>();

  premiumMembershipSelected = signal(0);

  //#endregion

  //#region Constructors

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['list'].currentValue.length)
      this.#getRecommendedMembership();
  }

  //#endregion

  //#region Methods

  next() {
    this.onNextStep
      .emit(this.premiumMembershipSelected());
  }

  selectCard(id: number) {
    this.premiumMembershipSelected.set(id);
  }

  #getRecommendedMembership() {
    this.premiumMembershipSelected.set(this.list().find(x => x.benefits)?.id ?? 0);
  }

  //#endregion
}
